import {CustomerListModuleConfiguration} from "./customer.list.module.configuration";
import {CustomerListComponent} from "./component/customer.list.component";


CustomerListModuleConfiguration.createNewModule()
    .component('customerList', CustomerListComponent.instance);